export default [
  {
    path: 'file',
    meta: {
      title: 'Files',
      auth: ['Admin', 'Super Admin'],
      hidden: true,
      icon: 'folder_shared'
    },
    component: () => import('./pages/index'),
    redirect: 'file/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'file',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'file',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'file',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
